
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"24","height":"24","rx":"2.5","fill":"#FF000B","stroke":"#fff","stroke-dasharray":"2 2"}}),_c('rect',{attrs:{"x":"12.5","y":"13.5","width":"24","height":"24","rx":"2.5","fill":"#0F9EB0","stroke":"#fff"}}),_c('path',{attrs:{"d":"M13.607 14.607a1 1 0 001-1v-9a1 1 0 10-2 0v8h-8a1 1 0 100 2h9zM2.293 3.707L12.9 14.314l1.414-1.415L3.707 2.293 2.293 3.707z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M13.607 14.607a1 1 0 001-1v-9a1 1 0 10-2 0v8h-8a1 1 0 100 2h9zM2.293 3.707L12.9 14.314l1.414-1.415L3.707 2.293 2.293 3.707z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M13.607 14.607a1 1 0 001-1v-9a1 1 0 10-2 0v8h-8a1 1 0 100 2h9zM2.293 3.707L12.9 14.314l1.414-1.415L3.707 2.293 2.293 3.707z","fill":"#FFFEFE"}}),_c('circle',{attrs:{"cx":"24","cy":"25","r":"6.5","stroke":"#fff"}}),_c('circle',{attrs:{"cx":"24","cy":"25","r":"4.5","stroke":"#fff"}}),_c('path',{attrs:{"stroke":"#fff","d":"M24.5 16v19M14.5 25h19"}})])
          )
        }
      }
    